export default {
  title: 'Réinitialisation du mot de passe',
  label: {
    email: 'Adresse email',
    password: 'Nouveau mot de passe',
    confirmPassword: 'Confirmation du nouveau mot de passe'
  },
  description: {
    1: 'Vous allez recevoir un e-mail avec un lien qui sera valide 24 heures',
    2: 'En cliquant sur ce lien vous arriverez sur une nouvelle page où vous pourrez choisir votre nouveau mot de passe pour vous connecter.'
  },
  descriptionAboutPassword: {
    title: 'Merci de choisir un nouveau mot de passe répondant aux critères suivants :',
    first: 'Au moins 8 caractères',
    second: 'Au moins une majuscule, une minuscule et un signe de ponctuation'
  }
}
